import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import { toast } from "sonner";
import "@/index.css";
import App from "@/App";

// Send cookies with every axios call (required for session auth)
axios.defaults.withCredentials = true;

// Global 401 interceptor: αυτόματη ανανέωση session (refresh token) και επανάληψη του αιτήματος
let refreshingPromise = null;
axios.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error?.config;
    const status = error?.response?.status;
    const url = original?.url || '';
    const isAuthCall = url.includes('/auth/login') || url.includes('/auth/refresh') || url.includes('/auth/logout') || url.includes('/auth/register');
    if (status === 401 && original && !original._retried && !isAuthCall) {
      original._retried = true;
      try {
        if (!refreshingPromise) {
          const base = process.env.REACT_APP_BACKEND_URL;
          refreshingPromise = axios.post(`${base}/api/auth/refresh`, {}, { withCredentials: true })
            .finally(() => { refreshingPromise = null; });
        }
        await refreshingPromise;
        return axios(original);
      } catch (e) {
        // refresh απέτυχε — συνεχίζει το αρχικό 401 (logout)
      }
    }
    return Promise.reject(error);
  }
);

// Global 402 interceptor: show friendly "insufficient credits" toast
axios.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 402) {
      const d = error.response.data?.detail;
      const msg = typeof d === 'object' ? (d?.message || 'Ανεπαρκείς μονάδες') : (d || 'Ανεπαρκείς μονάδες');
      try {
        toast.error(msg, {
          description: 'Ανοίξτε ρυθμίσεις → Συνδρομή για αγορά πακέτου.',
          duration: 6000,
        });
      } catch { /* toast not ready */ }
    }
    return Promise.reject(error);
  }
);

// Suppress ResizeObserver loop warning (common browser issue)
const resizeObserverErrDiv = document.createElement('div');
const resizeObserverErr = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends resizeObserverErr {
  constructor(callback) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
